import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { SectionButton } from 'react-mobiledoc-editor'
import CardButton from './CardButton'
import PhotoIcon from 'react-icons/lib/md/insert-photo'
import ListIcon from 'react-icons/lib/md/format-list-bulleted'
import NumberListIcon from 'react-icons/lib/md/format-list-numbered'
import QuoteIcon from 'react-icons/lib/md/format-quote'
import LineIcon from 'react-icons/lib/md/remove'
import Icon from '../Icon'

class BlockMenu extends React.Component {
  static contextTypes = {
    editor: PropTypes.object
  }

  state = {
    visible: false,
    menu: false,
    x: 0,
    y: 0
  }

  componentDidMount () {
    const {editor} = this.context
    editor.cursorDidChange(this.updateVisibility)
  }

  updateVisibility = () => {
    const {editor} = this.context
    if (!editor.range || !editor.range.head.section || !editor.range.head.section.isBlank || editor.range.head.section.renderNode._element.tagName.toLowerCase() !== 'p') {
      this.setState({visible: false, menu: false})
      return
    }

    const element = editor.range.head.section.renderNode._element
    const x = editor.element.offsetLeft + element.offsetLeft
    const y = editor.element.offsetTop + element.offsetTop

    this.setState({visible: true, x, y})
  }

  toggleMenu = () => {
    this.setState(prevState => ({menu: !prevState.menu}))
  }

  render () {
    const {visible, menu, x, y} = this.state

    return <div className={cn('editor-block-menu', {visible, menu})} style={{left: x, top: y}}>
      <button className='menu-button' onClick={this.toggleMenu} type='button'>
        <Icon name='plus' />
      </button>
      {menu &&
        <div className='menu-container'>
          <CardButton card='Image' type='button'>
            <PhotoIcon size={20} />
          </CardButton>
          <SectionButton tag='ul' type='button'>
            <ListIcon size={20} />
          </SectionButton>
          <SectionButton tag='ol' type='button'>
            <NumberListIcon size={20} />
          </SectionButton>
          <SectionButton tag='blockquote' type='button'>
            <QuoteIcon size={20} />
          </SectionButton>
          <CardButton card='Divider' type='button'>
            <LineIcon size={20} />
          </CardButton>
        </div>
      }
    </div>
  }
}

export default BlockMenu



// WEBPACK FOOTER //
// ./app/components/editor/BlockMenu.js